function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef, useState } from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import { createPortal } from '../../../_snowpack/pkg/react-dom.js';
import { usePopper } from '../../../_snowpack/pkg/react-popper.js';
import { Wrapper, Arrow } from './styles.js';
const config = {
  strategy: 'fixed',
  placement: 'right-end',
  modifiers: [{
    name: 'offset',
    options: {
      offset: [5, 8]
    }
  }]
};

function Tooltip(props) {
  const {
    children,
    render,
    theme,
    stayOpen
  } = props;
  const triggerRef = useRef(null);
  const popperRef = useRef(null);
  const arrowRef = useRef(null);
  const {
    styles,
    attributes,
    update
  } = usePopper(triggerRef.current, popperRef.current, config);
  const [show, setShow] = useState(false);
  useEffect(() => {
    update === null || update === void 0 ? void 0 : update();
  }, [stayOpen, update]);

  const handleMouseEnter = event => {
    event.stopPropagation();
    setShow(value => !value);
  };

  const handleMouseLeave = event => {
    event.stopPropagation();
    setShow(value => !value);
  };

  const tooltipProps = {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: triggerRef
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, render(tooltipProps), /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-theme": theme,
    ref: popperRef,
    role: "tooltip",
    style: styles.popper
  }, attributes.popper, {
    "data-show": show,
    "data-permanent": stayOpen
  }), children, /*#__PURE__*/React.createElement(Arrow, {
    ref: arrowRef,
    "data-popper-arrow": true,
    style: styles.arrow
  })), document.body));
}

Tooltip.defaultProps = {
  theme: 'light'
};
Tooltip.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark'])
};
export default Tooltip;